import React from 'react'
import { ConceptValues, ModuleSizes } from '../../../../../../../types/Survey/Analysis/Concept'
import props from '../../../../../../../redux/props'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import getSums from './getSums'
import Item from '../../../Summary/Item'
import { PrebuildMeetingGroesseBesprechungSubType, PrebuildMeetingGroesseCoworkingSubType } from '../../../../../../../types/Survey/Element'
import TableItem, { TableItemRow } from '../../../Summary/TableItem'

const Areas: React.FC<{ values: ConceptValues }> = ({ values }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const sums = getSums(values.ergebnisse)

  const sum = () => {
    const sumValues = [
      values.ergebnisse.EINZELARBEIT.KLASSISCHE_ARBEIT.practicalQM,
      values.ergebnisse.EINZELARBEIT.FOKUSSIERTE_ARBEIT_MORE_THEN_HOUR.practicalQM,
      values.ergebnisse.EINZELARBEIT.FOKUSSIERTE_ARBEIT_LESS_THEN_HOUR.practicalQM,
      sums.kommunikation,
      sums.kollaboration,
      sums.staufleache,
      sums.sonderbedarfe,
      sums.einzelbueros,
      sums.verkehrsflaechen,
    ]
    return _.sum(sumValues)
  }

  return (
    <div>
      <TableItem
        title={t.survey.analysis.concept.summary.areaOverview.arbeitsplaetze.label}
        value={sums.einzelarbeit + sums.einzelbueros}
        suffix={t.generic.squareMeterSuffix}
        doRound
        items={[
          <TableItemRow
            title={t.survey.analysis.concept.summary.areaOverview.arbeitsplaetze.KLASSISCHE_ARBEIT}
            values={[{ value: values.ergebnisse.EINZELARBEIT.KLASSISCHE_ARBEIT.practicalQM, suffix: t.generic.squareMeterSuffix }]}
          />,
          <TableItemRow
            title={t.survey.analysis.concept.summary.areaOverview.arbeitsplaetze.FOKUSSIERTE_ARBEIT_MORE_THEN_HOUR}
            values={[{ value: values.ergebnisse.EINZELARBEIT.FOKUSSIERTE_ARBEIT_MORE_THEN_HOUR.practicalQM, suffix: t.generic.squareMeterSuffix }]}
          />,
          <TableItemRow
            title={t.survey.analysis.concept.summary.areaOverview.arbeitsplaetze.einzelbueros}
            values={[{ value: sums.einzelbueros, suffix: t.generic.squareMeterSuffix }]}
          />,
        ]}
      />
      <TableItem
        title={t.survey.analysis.concept.summary.areaOverview.arbeitsorte.label}
        value={sums.kommunikation + sums.kollaboration + values.ergebnisse.EINZELARBEIT.FOKUSSIERTE_ARBEIT_LESS_THEN_HOUR.practicalQM}
        suffix={t.generic.squareMeterSuffix}
        doRound
        items={[
          <TableItemRow
            title={t.survey.analysis.concept.summary.areaOverview.arbeitsplaetze.FOKUSSIERTE_ARBEIT_LESS_THEN_HOUR}
            values={[{ value: values.ergebnisse.EINZELARBEIT.FOKUSSIERTE_ARBEIT_LESS_THEN_HOUR.practicalQM, suffix: t.generic.squareMeterSuffix }]}
          />,
          ...Object.keys(PrebuildMeetingGroesseBesprechungSubType).map((key) => {
            return (
              <TableItemRow
                key={key}
                title={t.survey.analysis.concept.summary.areaOverview.arbeitsorte[`KOMMUNIKATION_${key}`]}
                values={[{ value: values.ergebnisse.MEETING_GROESSE_BESPRECHUNG[key].practicalQM, suffix: t.generic.squareMeterSuffix }]}
              />
            )
          }),
          ...Object.keys(PrebuildMeetingGroesseCoworkingSubType).map((key) => {
            return (
              <TableItemRow
                key={key}
                title={t.survey.analysis.concept.summary.areaOverview.arbeitsorte[`KOLLABORATION_${key}`]}
                values={[{ value: values.ergebnisse.MEETING_GROESSE_COWORKING[key].practicalQM, suffix: t.generic.squareMeterSuffix }]}
              />
            )
          }),
          ...Object.keys(ModuleSizes).map((size) => {
            return (
              <TableItemRow
                key={size}
                title={t.survey.analysis.concept.summary.areaOverview.arbeitsorte[`HYBRID_PERSON_${size}`]}
                values={[{ value: values.ergebnisse.HYBRID[size].practicalQM, suffix: t.generic.squareMeterSuffix }]}
              />
            )
          }),
        ]}
      />
      <TableItem
        title={t.survey.analysis.concept.summary.areaOverview.sonderbedarfe.label}
        value={sums.sonderbedarfe}
        suffix={t.generic.squareMeterSuffix}
        doRound
        items={[
          ...values.SONDERBEDARFE.map((s) => {
            return <TableItemRow key={s.name} title={s.name} values={[{ value: s.practicalQM, suffix: t.generic.squareMeterSuffix }]} />
          }),
          <TableItemRow
            title={t.survey.analysis.calculation.values.drucker.headline}
            values={[{ value: sums.drucker, suffix: t.generic.squareMeterSuffix }]}
          />,
          <TableItemRow
            title={t.survey.analysis.calculation.values.locker.headline}
            values={[{ value: sums.locker, suffix: t.generic.squareMeterSuffix }]}
          />,
          <TableItemRow
            title={t.survey.analysis.calculation.values.workcafe.headline}
            values={[{ value: sums.workcafe, suffix: t.generic.squareMeterSuffix }]}
          />,
          <TableItemRow
            title={t.survey.analysis.calculation.values.garderobe.headline}
            values={[{ value: sums.garderobe, suffix: t.generic.squareMeterSuffix }]}
          />,
        ]}
      />
      <Item title={t.survey.analysis.calculation.values.stauflaeche.headline} value={sums.staufleache} suffix={t.generic.squareMeterSuffix} />
      <Item
        title={t.survey.analysis.calculation.values.verkehrsflaechen.headline}
        value={sums.verkehrsflaechen}
        suffix={t.generic.squareMeterSuffix}
      />
      <Item bold title={t.survey.analysis.calculation.values.sum.headline} value={sum()} suffix={t.generic.squareMeterSuffix} />
    </div>
  )
}

export default Areas
